import { freshnessFooter } from "../../utils/directorFormat";

// Rodapé de frescor das fontes. Usa <p> (e não <span>) por causa do reset global de span.
const FreshnessFooter = ({ freshness, prefix = null }) => {
  const footer = freshnessFooter(freshness);
  if (!footer) return null;
  return <footer className="director-freshness">
    {prefix && <p className="director-freshness__line">{prefix}</p>}
    <p className="director-freshness__line">{footer.line}</p>
    {footer.note && <p className="director-freshness__note">{footer.note}</p>}
  </footer>;
};

export default FreshnessFooter;
